(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ascii-invaders"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.vpASCIIInvadersReady) return;
    window.vpASCIIInvadersReady = true;

    const setImmersive = (section, active) => {
      section.classList.toggle('vp-ascii--immersive', active);
      document.documentElement.classList.toggle('vp-ascii-page-immersive', active);
      document.body.classList.toggle('vp-ascii-page-immersive', active);

      const button = section.querySelector('[data-ascii-fullscreen]');
      if (button) button.textContent = active ? button.dataset.exitLabel : button.dataset.enterLabel;

      if (active) {
        window.scrollTo(0, 0);
        const frame = section.querySelector('iframe');
        if (frame) frame.focus();
      }
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ascii-fullscreen]');
      if (!button) return;
      const section = button.closest('[data-ascii-invaders]');
      if (!section) return;
      setImmersive(section, !section.classList.contains('vp-ascii--immersive'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.vp-ascii--immersive').forEach((section) => setImmersive(section, false));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bridge-troll-simulator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.vpBridgeTrollReady) return;
    window.vpBridgeTrollReady = true;

    const setImmersive = (section, active) => {
      section.classList.toggle('vp-bridge--immersive', active);
      document.documentElement.classList.toggle('vp-bridge-page-immersive', active);
      document.body.classList.toggle('vp-bridge-page-immersive', active);

      const button = section.querySelector('[data-bridge-fullscreen]');
      if (button) {
        button.textContent = active ? button.dataset.exitLabel : button.dataset.enterLabel;
      }

      if (active) {
        window.scrollTo(0, 0);
        const frame = section.querySelector('iframe');
        if (frame) frame.focus();
      }
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bridge-fullscreen]');
      if (!button) return;

      const section = button.closest('[data-bridge-troll]');
      if (!section) return;

      setImmersive(section, !section.classList.contains('vp-bridge--immersive'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.vp-bridge--immersive').forEach((section) => {
        setImmersive(section, false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feed-the-homeless"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.vpFeedHomelessReady) return;
    window.vpFeedHomelessReady = true;
    const setImmersive = (section, active) => {
      section.classList.toggle('vp-feed--immersive', active);
      document.documentElement.classList.toggle('vp-feed-page-immersive', active);
      document.body.classList.toggle('vp-feed-page-immersive', active);
      const button = section.querySelector('[data-feed-fullscreen]');
      if (button) button.textContent = active ? button.dataset.exitLabel : button.dataset.enterLabel;
      if (active) { window.scrollTo(0,0); const frame=section.querySelector('iframe'); if(frame) frame.focus(); }
    };
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-feed-fullscreen]');
      if (!button) return;
      const section = button.closest('[data-feed-homeless]');
      if (!section) return;
      setImmersive(section, !section.classList.contains('vp-feed--immersive'));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.vp-feed--immersive').forEach((section) => setImmersive(section,false));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hunt-the-muglump"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.vpHuntMuglumpReady) return;
    window.vpHuntMuglumpReady = true;

    const setImmersive = (section, active) => {
      section.classList.toggle('vp-hunt--immersive', active);
      document.documentElement.classList.toggle('vp-hunt-page-immersive', active);
      document.body.classList.toggle('vp-hunt-page-immersive', active);
      if (active) window.scrollTo(0, 0);
    };

    window.addEventListener('message', (event) => {
      if (event.origin !== 'https://cor2879.github.io') return;
      if (!event.data || event.data.type !== 'hunt-muglump-immersive') return;

      document.querySelectorAll('[data-hunt-muglump]').forEach((section) => {
        const frame = section.querySelector('iframe');
        if (frame && event.source === frame.contentWindow) {
          setImmersive(section, Boolean(event.data.active));
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.vp-hunt--immersive').forEach((section) => setImmersive(section, false));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["synthbreak"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.vpSynthbreakReady) return;
    window.vpSynthbreakReady = true;

    const setImmersive = (section, active) => {
      section.classList.toggle('vp-synth--immersive', active);
      document.documentElement.classList.toggle('vp-synth-page-immersive', active);
      document.body.classList.toggle('vp-synth-page-immersive', active);

      const button = section.querySelector('[data-synth-fullscreen]');
      if (button) button.textContent = active ? button.dataset.exitLabel : button.dataset.enterLabel;

      if (active) {
        window.scrollTo(0, 0);
        const frame = section.querySelector('iframe');
        if (frame) frame.focus();
      }
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-synth-fullscreen]');
      if (!button) return;
      const section = button.closest('[data-synthbreak]');
      if (!section) return;
      setImmersive(section, !section.classList.contains('vp-synth--immersive'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.vp-synth--immersive').forEach((section) => setImmersive(section, false));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yumhuman"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.vpYumHumanReady) return;
    window.vpYumHumanReady = true;

    const setImmersive = (section, active) => {
      section.classList.toggle('vp-yum--immersive', active);
      document.documentElement.classList.toggle('vp-yum-page-immersive', active);
      document.body.classList.toggle('vp-yum-page-immersive', active);

      const button = section.querySelector('[data-yum-fullscreen]');
      if (button) button.textContent = active ? button.dataset.exitLabel : button.dataset.enterLabel;

      if (active) {
        window.scrollTo(0, 0);
        const frame = section.querySelector('iframe');
        if (frame) frame.focus();
      }
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-yum-fullscreen]');
      if (!button) return;
      const section = button.closest('[data-yumhuman]');
      if (!section) return;
      setImmersive(section, !section.classList.contains('vp-yum--immersive'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.vp-yum--immersive').forEach((section) => setImmersive(section, false));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
